import React, { FC } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';

const LoaderContainer = styled.div`
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100vw;
  height: 100vh;
  background: var(--white-90);
  position: fixed;
  z-index: 1012;
  flex-direction: column;
`;

const MessageContainer = styled.div`
  text-align: center;
  padding: var(--spacing-08);
`;

export const PreviewLoader: FC = () => {
  return (
    <LoaderContainer>
      <MessageContainer>
        <h3>
          <FormattedMessage id="projects.preview.loader.title" />
        </h3>
        <h5>
          <FormattedMessage id="projects.preview.loader.description" />
        </h5>
      </MessageContainer>
    </LoaderContainer>
  );
};
